<template>
    <form @submit.prevent="submit">
        <div class="token-info">
            <p class="reset-password-information auth-layout-text-and-icon">
                {{ 'Eine E-Mail mit einem Passwort Reset Token wird an Ihre Email gesendet.' | translate }}
            </p>
        </div>

        <input class="auth-email auth-layout-login-form-text caps-warning auth-layout-secondary"
               @focusout="validateField('email')"
               v-model="email" id="email" type="text" name="email"
               :class="{ invalid: errors.has('email'), valid: isValid('email') }"
               :data-vv-as="'E-Mail' | translate"
               v-validate="'required|email'"
               :placeholder="'E-Mail' | translate"
        >
        <label :data-error="errors.first('email')"
               class="error-handler">
        </label>
        <button
            class="auth-login wave auth-layout-tertiary auth-layout-button-text auth-layout-tertiary-border-color"
            :class="{'disabled-button' : isButtonDisabled }"
            type="submit"
            :disabled="isButtonDisabled"
        >
            {{ 'Token senden' | translate }}
        </button>
        <p class="small-small">
            <router-link class="forget-password auth-layout-tertiary-font-color"
                         :to="{name:'Login'}">
                {{ 'Abbrechen' | translate }}
            </router-link>
        </p>
    </form>
</template>

<style scoped>
input[type=text]:not(.browser-default):focus:not([readonly]):not(.invalid),
input[type=password]:not(.browser-default):focus:not([readonly]):not(.invalid) {
    border: 1px solid #1c82bf;
}

input:-webkit-autofill::placeholder,
input:-webkit-autofill::-webkit-input-placeholder {
    display: none;
}
</style>

<script>
import {translate} from 'pf/filter';
import Noty from "noty";

export default {
    filters: {
        translate
    },
    methods: {
        validateField(field) {
            if (!this[field]) {
                this.$validator.errors.clear(field);
            }
            this.$validator.validate(field);
        },
        isValid(key) {
            return !this.errors.has(key) && this.fields[key] && this.fields[key].touched;
        },
        validate() {
            return this.$validator.validate();
        },
        submit() {
            this.validate()
                .then((success) => {
                    if (!success) return;
                    this.$store.dispatch('forget')
                        .then(() => {
                            new Noty ({
                                type: "success",
                                theme: "mint",
                                layout:"topRight",
                                text: translate('E-Mail versendet!'),
                                timeout: 6000,
                            }).show();
                            this.$router.push({
                                name: 'ChangePassword',
                            });
                        })
                        .catch(() => {
                            new Noty ({
                                type: "error",
                                theme: "mint",
                                layout:"topRight",
                                text: translate('E-Mail Adresse überprüfen!'),
                                timeout: 6000,
                            }).show();
                        });
                });
        }
    },
    computed: {
        isButtonDisabled() {
            const isEmailValid = !this.errors.has('email');
            return !(isEmailValid);
        },
        email: {
            set(value) {
                this.$store.commit('setEmail', value);
            },
            get() {
                return this.$store.state.email;
            }
        },
    }
}
</script>
